import React from "react";
import { withTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";
import moment from "moment";

import SectionCard from "../SectionCard";
import SubSection from "../SubSection";
import FieldRow from "../FieldRow";

import "./index.scss";

const DealerCarInfoHeader = ({ appointment, t }) => {
  const {
    dealer_location: { dealer },
    car,
  } = appointment;

  return (
    <div className="DealerCarInfoHeader">
      <SectionCard title={t("cc_dealer_and_car_info").message || "Dealer and Car Info"} icon={<Icon name="info circle" />}>
        <SubSection title={t("cc_dealer_details").message || "Dealer Details"} icon={<Icon name="user" />}>
          <FieldRow
            fields={[
              { label: t("cc_name").message || "Name", value: dealer?.name },
              { label: t("cc_address").message || "Address", value: dealer?.street },
              { label: t("cc_email").message || "Email", value: dealer?.email },
              { label: t("cc_url").message || "URL", value: dealer?.website_url },
              { label: t("cc_Phone_number").message || "Phone Number", value: dealer?.phone_nr },
            ]}
          />
        </SubSection>

        <SubSection title={t("cc_car_details").message || "Car Details"} icon={<Icon name="car" />}>
          <FieldRow
            fields={[
              { label: `${t("cc_registration").message || "Registration"}#`, value: car?.reg_nr },
              { label: `${t("cc_vin_chasis").message || "Vin/Chasis"}#`, value: car?.vin_nr },
              { label: t("cc_make").message || "Make", value: car?.make },
              { label: t("cc_model").message || "Model", value: car?.model },
              { label: t("cc_current_km").message || "Current Km", value: appointment?.current_km },
              { label: t("cc_apk").message || "APK", value: moment(car?.apk_date_dms).format("DD-MM-YYYY") },
            ]}
          />
        </SubSection>
      </SectionCard>
    </div>
  );
};

export default withTranslation()(DealerCarInfoHeader);
